import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ProgressStepContentModel } from './progress-step-content-model';
import { TextModel } from './text-model';
import { ITextProps } from '../components/text/text';
import { IProgressStepContentProps } from '../components/progress-steps/progress-step-content/progress-step-content';
import { IProgressStepsProps } from '../components/progress-steps/progress-steps';

export class ProgressStepsModel extends ContentItem {
  get progressStepsItems(): ITextProps[] {
    const getProgressStepsItems = get(
      this._config,
      'elements.step_items.value',
      []
    );
    const transformStepItems = getProgressStepsItems
      ? getProgressStepsItems.map((stepItem: IText) =>
          TextModel.create(stepItem)
        )
      : null;
    return transformStepItems;
  }

  get progressStepsContent(): IProgressStepContentProps[] {
    const getProgressStepsContent = get(
      this._config,
      'elements.step_content.value',
      []
    );
    const transformProgressStepsContent = getProgressStepsContent
      ? getProgressStepsContent.map((stepContent: IProgressStepContent) =>
          ProgressStepContentModel.create(stepContent)
        )
      : null;
    return transformProgressStepsContent;
  }

  public static create(data: IProgressSteps): IProgressStepsProps {
    const { progressStepsItems, progressStepsContent } = new ProgressStepsModel(
      data
    );
    return {
      progressStepsItems,
      progressStepsContent
    };
  }
}
